<mat-form-field
  appearance="outline"
  class="{{ formFieldClass }}"
  [ngClass]="{ 'mat-form-field-readonly': readonly }"
>
  <mat-label [ngClass]="{ 'label-text-readonly': readonly }">{{
    label | translate
  }}</mat-label>
  <input
    matInput
    type="number"
    [formControl]="control"
    [min]="minValue!"
    [max]="maxValue!"
    (keypress)="blockDecimal($event)"
    [style.paddingRight]="suffix ? '2em' : null"
    [readonly]="readonly"
  />

  <mat-error
    *ngIf="control.hasError('required') && control.touched && required"
  >
    {{ requiredLabel | translate }}
  </mat-error>

  <mat-error *ngIf="control.hasError('min') && control.touched">
    {{ "input.only-positive" | translate }}
  </mat-error>

  <mat-error *ngIf="control.hasError('notInteger') && control.touched">
    {{ "input.only-integer" | translate }}
  </mat-error>

  <mat-error
    *ngIf="control.invalid && control.hasError('max') && control.touched"
  >
    {{ "max-value-exceeded" | translate }}
  </mat-error>
</mat-form-field>
